import React from 'react'
import {FieldFormElementProps} from "../../../render/form-elemnent";
import FieldAddress_FormElementView from "./form-element-view";

const debug = false
// const debug = "FieldAddress_FormElement"

export default function FieldAddress_FormElement(props:FieldFormElementProps) {

    const onChange = (value: Moment) => {

        if (props.form) {
            props.form.onFormComponentValueChange(props.field.fieldId, value)
        }
    }

    return (
        <FieldAddress_FormElementView  field     = {props.field}
                                       model     = {props.model}
                                       onChange  = {onChange}
                                       className = {props.className} />
    )

}
